module.exports = __webpack_public_path__ + "img/purple_tip.76b5a652.jpg";